import { observable } from 'mobx'
import { Model, type ModelProps } from '@/infra/model'
import { unixEpoch } from '@/utils/date-util'
import { Id } from '@/infra/id'
import type {
  OCRScopeWorkEngineStatus,
  OCRScopeWorkJobStatus,
  OCRScopeWorkStatus,
} from './ocr-scope-work-status'

export type OCRScopeWorkProps = ModelProps<OCRScopeWork>

/**
 * A document being scoped into a job by OCR.
 */
export class OCRScopeWork extends Model<OCRScopeWork> {
  /**
   * Sentinel none value.
   */
  static readonly none = new OCRScopeWork()

  id = Id.none

  @observable accessor archived = false
  @observable accessor confidenceLevel = ''
  @observable accessor createdByName = ''
  @observable accessor dateCreated = unixEpoch()
  @observable accessor fileName = ''
  @observable accessor jobId = Id.none
  @observable accessor jobName = ''
  @observable accessor legendId = Id.none
  @observable accessor legendVersion = 0
  @observable accessor status: OCRScopeWorkStatus = 'Unknown'
  @observable accessor engineStatus: OCRScopeWorkEngineStatus = 'Other'
  @observable accessor jobStatus: OCRScopeWorkJobStatus = 'Other'
  @observable accessor teamId = Id.none
  @observable accessor templateId = Id.none
  @observable accessor userPublicId = Id.none
  @observable accessor workspaceId = Id.none
}

/**
 * A realtime change to a scope work.
 */
export type OCRScopeWorkEvent = ScopeWorkChanged | ScopeWorkArchived

/**
 * A scope work was created or changed status.
 */
interface ScopeWorkChanged {
  type: 'Created' | 'Updated' | 'NeedsAttention' | 'Errored' | 'Submitted'
  scopeWork: OCRScopeWork
}

/**
 * A scope work was archived.
 */
interface ScopeWorkArchived {
  type: 'Archived'
  scopeWorkId: Id
}
